import { Col, Icon, Select,Row, Input, Spin, message } from 'antd'
import SelectTimezone  from "./timezone";
import TextArea from 'antd/lib/input/TextArea';
import axios from 'axios';
import moment from 'moment';
import React, { useEffect, useState,forwardRef, useImperativeHandle } from 'react'
import DatePicker from "react-datepicker";
import F from "../../../Functions";
const Option = Select.Option;


const Microsoft_apppointment = forwardRef((props,_ref) => {
   const [loading, setloading] = useState(false)
   const [data, setdata] = useState({
      booking_page_name_inputted:"",
      busines_hours:[],
      busines_hours_anyone:[],
      date:moment(),
      service_meet_default_duration:"",
      service_name:"",
      selectedStaffMemberIds:"",
      staffMemberList:[],
      selectedDate: moment().day(),
      service_url:"",
      filtered_questions:[],
      frontend_answers:[],
      timezone:""
   })

   const getDayNumber = {
      sunday:0,
      monday:1,
      tuesday:2,
      wednesday:3,
      thursday:4,
      friday:5,
      saturday:6,
   }


   useEffect(()=>{
    props.appointment_date(moment(data.date).format("YYYY-MM-DD HH:mm:ss"))
   },[])

   useEffect(() => {
    setloading(true)


      axios.get(`/api/msbooking/display_selected/${props.lsp}?service_type=${props.service_type}`).then(({data:{success,service_inputs,error_response,service_url}})=>{
        if(success && !error_response){
           setdata((prev)=>({...prev,
              booking_page_name_inputted:service_inputs.booking_page_name_inputted||"",
              busines_hours:service_inputs.busines_hours||[],
              busines_hours_anyone:service_inputs.busines_hours||[],
              service_meet_default_duration:service_inputs.service_meet_default_duration || "",
              service_name:service_inputs.service_name||"",
              service_url,
              }))

             let liststaff = new Promise((resolve,reject)=>{
              axios.post(`/api/msbooking/list_staff_members/${props.lsp}`,{staffMemberIds:service_inputs.staffMemberIds}).then(({data:{success,error_response,staff_display}})=>{
                if(success && !error_response){
                  setdata(prev=>({...prev,staffMemberList:staff_display||[]}))
                  resolve()
                }else{
                  reject()
                  message.error(error_response)
                }
                     })
             })
             
             let customQuestion = new Promise((resolve,reject)=>{
              axios.post(`/api/msbooking/list_filtered_custom_questions/${props.lsp}`,{
                customQuestions:service_inputs.customQuestions
               }).then(({data:{success,filtered_questions}})=>{
                if(success){
                  setdata(prev=>({...prev,filtered_questions}))
                  resolve()
                }else{
                  reject()
                  message.error(error_response)
                }
               })
             })


             Promise.allSettled([liststaff,customQuestion]).finally(()=>{
              setloading(false)
             })
              
        }else{
          props.onChangeScheduledVia({target:{value:"Internal System"}})
          setloading(false)
          message.error(error_response)
        }
    })
  


   }, [props.lsp,props.service_type])


   useImperativeHandle(_ref,()=>({
    getState:()=>{
      return data;
    },
    getTimeInterval:()=>{
       return getTimeInterval();
      }
   }))

   const disabledDate = (date) => {
    const today = moment().startOf('day');
    const selectedDay = moment(date).startOf('day');
    
    // Disable past dates
    if (selectedDay.isBefore(today)) {
      return false;
    }
    
    // Disable days without time slots
    const daysToDisable = data.busines_hours
      .filter(e => !e.timeSlots.length)
      .map(e => getDayNumber[e.day]);
    const day = selectedDay.day();
    if (daysToDisable.includes(day)) {
      return false;
    }
    
    // Allow all other dates
    return true;
  };
  


   const updateFeild = ({name,value})=>{
  
      if(name==='date'){
        props.appointment_date(value)
        const selectedDay = moment(value).startOf('day');
        const day = selectedDay.day();
         setdata(prev=>({...prev,selectedDate:day, [name]:value}))
      }else{
         setdata((prev)=>({...prev,[name]:value}))
      }   
   }

   const isTimeWithinRanges = (time) => {
    const selectedDate = data.selectedDate;

    if (selectedDate === undefined) return false;

    const timeRanges = data.busines_hours.find(e => getDayNumber[e.day] === selectedDate);
    const ranges = timeRanges && timeRanges.timeSlots ? timeRanges.timeSlots : [];

    return ranges.some(range => {
      const startTime = moment(range.startTime, 'HH:mm:ss');
      const endTime = moment(range.endTime, 'HH:mm:ss');
      const timeToCheck = moment(time).clone().set({
        'year': startTime.year(),
        'month': startTime.month(),
        'date': startTime.date()
      });
      return timeToCheck.isBetween(startTime, endTime, null, '[]');
    });
  };



  const getTimeInterval = () => {
    const duration = data.service_meet_default_duration.split("PT")[1];
    if (duration && duration.includes('M')) {
      return parseInt(duration.match(/\d+/)[0], 10);
    }
    if (duration && duration.includes('H')) {
      return parseInt(duration.match(/\d+/)[0], 10) * 60;
    }
    return 1; // default interval
  };



  const onChangeStaff = (e)=>{
    if(e !== ""){
      let temp =  data.staffMemberList.find(event=>event.id === e)
      setdata(prev=>({...prev,selectedStaffMemberIds:e,busines_hours:temp.workingHours}))
    }else{
      setdata(prev=>({...prev,selectedStaffMemberIds:e,busines_hours:data.busines_hours_anyone}))
    }
  }


 const onChangeFilteredQuestion = ({id,answer})=>{
    let prevfrontend_answers =  data.frontend_answers;
    let findIndex =  prevfrontend_answers.findIndex(e=>e.id === id);

    if(prevfrontend_answers[findIndex]){
         prevfrontend_answers[findIndex] = {id,answer}
    }else{
      prevfrontend_answers.push({id,answer})
    }
    setdata((prev)=>({...prev,frontend_answers:prevfrontend_answers}))
  }  
  
  
  
   const filtered_questions_list = ({answerInputType,answerOptions,displayName,id,isRequired})=>{
       if(answerInputType==="radioButton"){
           return (<div style={{marginTop:10}}>
         <label>{displayName} {isRequired ? <span style={{color:'red'}}>*</span> : '(optional)'}</label>
            <Select style={{width:'100%'}} onChange={(answer)=>onChangeFilteredQuestion({id,answer})} placeholder={displayName}>
            <Option value="">Select Appointment location</Option>
            {answerOptions.map((e,i)=>{
              return(
                <Option key={i} value={e}>{e}</Option>
              )
            })}
           </Select>
           </div>)
       }
       if(answerInputType==="text"){
          return (<div style={{marginTop:10}}>
          <label>{displayName} {isRequired ? <span style={{color:'red'}}>*</span> : '(optional)'}</label>
          <Input required={isRequired} onChange={(answer)=>onChangeFilteredQuestion({id,answer:answer.target.value})} placeholder={displayName} />
        </div>)
       }else{
        return null
       }
   }

  return (
    <Spin spinning={loading}>
         <Row style={{marginTop:10}}>
           <Col span={24}> Booking Page Name: <span style={{fontWeight:'bold'}}>{data.booking_page_name_inputted}</span> </Col>
         </Row>
         <Row>
          <Col span={24}> Booking for <span style={{fontWeight:'bold'}}>{data.service_name}</span></Col>
         </Row>
         <Row style={{marginTop:10}} gutter={8}>
            <Col span={12}>
          
             <label>  <Icon type="user" />  Select Staff (Optional)</label>
             <Select onChange={(e)=>onChangeStaff(e)} style={{width:'100%'}}  value={data.selectedStaffMemberIds} placeholder="Select Staff">
              <Option value={""}>Anyone</Option>
              {data.staffMemberList.map(e=>{
                return(
                  <Option key={e.id} value={e.id}>{e.displayName}</Option>
                )
              })}
             </Select>
            </Col>

            <Col span={12}>
                <label>Select Date and Time</label>
           <div>
           <DatePicker
        className='datepicker'
        selected={data.date ? moment(data.date).toDate() : null}
        onChange={(date) => 
          updateFeild({
            name: 'date',
            value: date ? moment(date).format("YYYY-MM-DD HH:mm:ss") : null,
          })
        }
        showTimeSelect
        showYearDropdown
        timeIntervals={1} 
        timeFormat="hh:mm aa"
        dateFormat="MM/dd/yyyy h:mm aa"
        shouldCloseOnSelect={false}
        // filterDate={disabledDate}
        // filterTime={(time) => isTimeWithinRanges(time)}
        minTime={moment('00:00:00', 'HH:mm:ss')}
        maxTime={moment('23:59:59', 'HH:mm:ss')}
      />
           </div>
            </Col>
        
        </Row>

       {data.service_url && <Row style={{marginTop:10}}><a target="_blank" href={data.service_url}>Check Availability</a></Row>}

       <Row>
  {data.filtered_questions && data.filtered_questions.map((e,i)=>{
     return <span key={i}>
      {filtered_questions_list(e)}
     </span>
  })}
       </Row>

       {/* <Row style={{marginTop:10}}>
        <label>Select Timezone:</label>
        <SelectTimezone 
         unselectLabel="Select Timezone" 
         style={{width:'100%'}} 
         placeholder="Select Timezone" 
         onChange={(e)=>setdata((prev)=>({...prev,timezone:e}))} 
         value={data.timezone} />
       </Row> */}
      
         <Row >
            <Col span={24}>
           <Row>
            <Col  style={{marginTop:10}} >
            <label>Name:</label>
            <Input disabled value={props.bfile.first_name + " "+ props.bfile.last_name} />
            </Col>
           </Row>
            </Col>

            <Col span={24}>
           <Row>
            <Col  style={{marginTop:10}} >
            <label>Phone Number:</label>
            <Input disabled value={F.phone_format(props.bfile.phone.trim().replace(/[^0-9]/g, ''))} />
            </Col>
           </Row>
            </Col>
           
            
         </Row>
    </Spin>
  )
});

export default Microsoft_apppointment


// WEBPACK FOOTER //
// ./src/scenes/LandingPage/parts/microsoft_apppointment.js